<div class="group">
  <button type="button" [class]="classes()" (click)="clicked.emit($event)">
    @if (leadingIcon(); as leading) {
      <ml-icon [name]="leading" size="sm"></ml-icon>
    }

    <span class="truncate">{{ label() }}</span>
    @if (trailingIcon(); as trailing) {
      <ml-icon [class]="trailingIconClasses()" [name]="trailing" [size]="trailingIconSize()"></ml-icon>
    }
  </button>
</div>
